<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      append-to-body
      class="materialTypeSelect-dialog"
      title="选择物料类型"
      width="600px">
    <div>
      <div v-loading="loading">
        <el-input v-model="filterText" style="width: 200px" placeholder="输入关键字进行过滤"/>
        <el-tree
            ref="tree"
            :data="data"
            :props="defaultProps"
            :filter-node-method="filterNode"
            node-key="id"
            default-expand-all
            :expand-on-click-node="false">
          <span slot-scope="{ node, data : item }" class="custom-tree-node">
            <div style="width: 100%" @click="onSelect(item)">{{node.label}}</div>
          </span>
        </el-tree>
      </div>
    </div>
  </el-dialog>
</template>
<script>
  export default {
    name: "MaterialTypeSelector",
    data() {
      return {
        dialogVisible: false,
        loading: false,
        filterText: "",
        data: [
          {
            id: 0,
            materialTypeName: "全部",
            parentID: 0,
            children: [],
          },
        ],
        defaultProps: {
          children: "children",
          label: "materialTypeName",
        },
      };
    },
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      },
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.filterText = "";
        this.getData();
      },
      getData() {
        this.loading = true;
        this.$http.get("basic", "materialTypes/tree").then((res) => {
          if (res) {
            console.log(res.data);
            this.loading = false;
            this.data[0].children = JSON.parse(JSON.stringify(res.data));
          } else {
            this.loading = false;
            this.$message.error("获取数据出错");
          }
        });
      },
      filterNode(value, data, node) {
        if (!value) {
          return true;
        }
        if (node.parent.parent !== null && node.parent.visible) {
          return true;
        }
        return node.label.indexOf(value) !== -1;
      },
      onSelect(data) {
        this.$emit("select", { id: data.pkid, name: data.materialTypeName });
        this.dialogVisible = false;
      },
    },
  };
</script>
<style lang="scss">
.materialTypeSelect-dialog.el-dialog__header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}
.materialTypeSelect-dialog .el-dialog__footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.materialTypeSelect-dialog .el-dialog {
  margin: 2% auto !important;
  transform: scale3d(1, 1, 1);
  padding-bottom: 69px;
  height: 90%;
}

.materialTypeSelect-dialog .el-divider--horizontal {
  margin: 10px 0;
}

.materialTypeSelect-dialog .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: scroll;
}
.materialTypeSelect-dialog .custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>
